import { memo, useMemo, type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import { Button } from '../../../../Controls/Button/index.tsx';
import type { TitleProps } from '../../types.ts';
import {
  ContentWrapper,
  Wrapper,
  ExpandableButtonWrapper,
  ActionsWrapper,
  TitleAndFiltersWrapper,
  TitleAndExpandableButtonWrapper,
} from './styled.ts';
import { TitleContent } from './TitleContent.tsx';

export const Title: FC<TitleProps> = memo(function Title({ title, tooltip, tag, actions, icon, iconPosition = 'right', onIconClick }) {
  const isMobile = useMediaQuery({ query: Media.xsMax });

  const iconButton = useMemo(
    () =>
      icon && onIconClick ? (
        <ExpandableButtonWrapper $position={iconPosition}>
          <Button onClick={onIconClick} ghost iconOnly dataTestId='section-icon-button'>
            {icon}
          </Button>
        </ExpandableButtonWrapper>
      ) : null,
    [icon, onIconClick, iconPosition],
  );

  if (isMobile)
    return (
      <Wrapper>
        <ContentWrapper>
          <TitleAndExpandableButtonWrapper $iconPosition={iconPosition}>
            {iconPosition === 'left' && iconButton}
            {title && <TitleContent title={title} tooltip={tooltip} tag={tag} />}
            {iconPosition === 'right' && iconButton}
          </TitleAndExpandableButtonWrapper>
          {actions}
        </ContentWrapper>
      </Wrapper>
    );

  return (
    <Wrapper>
      {iconPosition === 'left' && iconButton}

      <ContentWrapper>
        <TitleAndFiltersWrapper>{title && <TitleContent title={title} tooltip={tooltip} tag={tag} />}</TitleAndFiltersWrapper>
        {actions && <ActionsWrapper>{actions}</ActionsWrapper>}
      </ContentWrapper>

      {iconPosition === 'right' && iconButton}
    </Wrapper>
  );
});
